import { render, staticRenderFns } from "./DeviceItem.vue?vue&type=template&id=5af28ad7"
import script from "./DeviceItem.vue?vue&type=script&lang=js"
export * from "./DeviceItem.vue?vue&type=script&lang=js"
import style0 from "./DeviceItem.vue?vue&type=style&index=0&id=5af28ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports